<input placeholder="{{'questionBoard.edit.placeholder' | translate}}">
<!-- [formControl]="questionForm.controls.text" -->